import React from "react";
import { Login } from "../features";

function LoginPage() {
  return <Login />;
}

export default LoginPage;
